export class Course {
  id = -1
  name = ''
  description = ''
  price = 0.0

  static emptyCourse () {
    const course = new Course()
    return course
  }

  static newCourse (id:number, name:string, description:string, price:number) {
    const course = new Course()

    course.id = id
    course.name = name
    course.description = description
    course.price = price

    return course
  }

  copyCourse (courseToCopy:Course) {
    this.id = courseToCopy.id
    this.name = courseToCopy.name
    this.description = courseToCopy.description
    this.price = courseToCopy.price
  }
}
